import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		bottomTab: {
			textAlign: "center",
			cursor: "pointer"
		},
		selectText: {
			...{ color: theme.palette.primary.main },
		},
		selectIcon: {
			color: theme.palette.primary.main,
			width: 16,
			height: 16,
			top: "calc(50% - 8px)",
		},
	} satisfies Record<string, CSSObject>);
};
